// extracted by mini-css-extract-plugin
export default {"wrapper":"workflowstatus_wrapper__SLenk","status":"workflowstatus_status__EIHDK"};